export { default, getStaticProps } from '~/pages/catalog';
